import { render, staticRenderFns } from "./Cons.vue?vue&type=template&id=5314a108&"
import script from "./Cons.vue?vue&type=script&lang=js&"
export * from "./Cons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports